import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9f31896a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "check-item" }
const _hoisted_2 = { class: "check-item-avatar" }
const _hoisted_3 = { class: "check-item-name" }
const _hoisted_4 = { class: "check-item" }
const _hoisted_5 = { class: "check-item-avatar" }
const _hoisted_6 = { class: "check-item-name" }

import { useChatStore } from "@/store/chatStore";
import { ref } from "vue";
import Avatar from "@/components/Avatar.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ChatsRadio',
  emits: ["setData"],
  setup(__props, { emit }) {


const chatStore = useChatStore();
const rightArr = ref([]);

const change = () => {
  emit("setData",rightArr.value)
};



return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createBlock(_component_el_row, { gutter: 10 }, {
    default: _withCtx(() => [
      _createVNode(_component_el_col, {
        span: 12,
        style: {"background-color":"#f8f8f8"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_checkbox_group, {
            modelValue: rightArr.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((rightArr).value = $event)),
            onChange: change
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chatStore).chats, (chat) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: chat.id,
                  style: {"height":"60px"}
                }, [
                  _createVNode(_component_el_checkbox, { label: chat }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                          _createVNode(Avatar, {
                            img: chat.avatar,
                            name: chat.name
                          }, null, 8, ["img", "name"])
                        ]),
                        _createElementVNode("div", _hoisted_3, _toDisplayString(chat.name), 1)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["label"])
                ]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_col, { span: 12 }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rightArr.value, (chat) => {
            return (_openBlock(), _createElementBlock("div", {
              key: chat.id,
              style: {"height":"60px"}
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(Avatar, {
                    img: chat.avatar,
                    name: chat.name
                  }, null, 8, ["img", "name"])
                ]),
                _createElementVNode("div", _hoisted_6, _toDisplayString(chat.name), 1)
              ])
            ]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})